module.exports = __webpack_public_path__ + "static/media/somwang_use_daycash.ac16fc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/somwang_use_daycash.png
// module id = 337
// module chunks = 0 11